export default __webpack_public_path__ + "static/media/resume.9cf3cca0.pdf";